var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ErrorTemplate',{attrs:{"margin-after-image":""},on:{"onAction":_vm.onAction}})}
var staticRenderFns = []

export { render, staticRenderFns }